// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3tAfF","content":"ManualTimeModal_content__UoHqY"};